import {
    extend,
    getDocument,
    getWindow,
    ssrDocument,
    ssrWindow,
} from 'ssr-window';
import 'fast-text-encoding';
/*    This here class helps us handle Server-Side rendering of React components
By mocking the document and window objects, we can postpone rewriting some of the old components
Usage: import { window, document } from './util/ssrWindow'
Et voìla!     */

extend(ssrDocument, {
    /* eslint-disable */ getElementsByClassName(): Array<object> {
        return new Array();
    },
    getElementsByTagName(): Array<object> {
        return new Array();
    },
    documentElement: {
        style: { setProperty: (key: string, value: string) => {} },
    },
    /* eslint-enable */
});
extend(ssrWindow, {
    Element: {
        prototype: {},
    },
    server: true,
    devToolsExtension: null,
    TextEncoder: new TextEncoder(),
    navigator: {
        userAgent: '',
        platform: '',
    },
});
const window = getWindow();
const document = getDocument();
const isServer = getWindow().navigator.userAgent === '';

if (globalThis.document === undefined || globalThis.document === null)
    globalThis.document = document;

if (globalThis.window === undefined || globalThis.window === null) {
    // @ts-expect-error Window is not assignable to globalThis, but leaflet needs it
    globalThis.window = window;
}

if (globalThis.navigator === undefined || globalThis.navigator === null)
    globalThis.navigator = window.navigator;

export { window };
export { document };
export { isServer };